<template lang="pug">
	.creative--aggregated-track-criteria-editor
		CommonServiceCriteriaEditor(ref="commonEditor", :templateFields="templateFields", :allowKeyEditing="allowKeyEditing", @save="save", @create-template-field="(a,b,c) => $emit('create-template-field', a, b, c)", @apply="onApply")
			DxDropDownButton(slot="actions-left", v-if="availableAggregatedTracks.length", :text="$tCaption('Copy from')", :data-source="availableAggregatedTracks", keyExpr="id", displayExpr="name", 
				stylingMode="contained", icon="fas fa-copy", @itemClick="onCopyFromClick")
</template>

<script>
	import _ from 'lodash';
	import CommonServiceCriteriaEditor from './CommonServiceCriteriaEditor.vue';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';

	export default {
		translationCategory: 'creative.AggregatedTrackCriteriaEditor',
		name: 'creative--aggregated-track-criteria-editor',
		components: {
			CommonServiceCriteriaEditor, DxDropDownButton
		},
		props: ['templateFields', 'allowKeyEditing', 'tracker'],
		data() {
			return {
				aggregatedTrack: null
			};
		},
		computed: {
			availableAggregatedTracks() {
				return (this.tracker?.aggregatedTracks || []).filter(f => f.trackNumber !== this.aggregatedTrack?.trackNumber);
			}
		},
		methods: {
			onCopyFromClick(e) {
				var item = e?.itemData;
				if (__DEBUG__)
					console.debug('onCopyFromClick', { e, item });
				this.$set(this.aggregatedTrack, 'condition', _.cloneDeep(item.condition));
				this.$refs.commonEditor.loadCondition(this.aggregatedTrack.condition);
			},
			onApply() {
				this.$confirm(void 0, this.$tCaption('Do you want to apply selected parameters for all tracks?')).then(() => {
					this.applyEditingOutputValueToAllTracks();
				});
			},
			applyEditingOutputValueToAllTracks() {
				let editor = this.$refs.commonEditor;
				let params = editor.params[editor.editorPopup.output.id];
				let paramsCaptions = editor.paramsCaptions[editor.editorPopup.output.id];
				let serviceKey = editor.editorPopup.output.id.split('.output_')[0];
				
				this.tracker.aggregatedTracks.map(aggTrack => {
					if (aggTrack?.condition) {
						let paramsKeys = Object.keys(aggTrack?.condition?.params || {});
						paramsKeys.map(key => {
							if (__DEBUG__)
								console.debug(`applyEditingOutputValueToAllTracks ${aggTrack.trackNumber} ${key}, sk: ${serviceKey}`);
							if (key.startsWith(serviceKey) && (aggTrack?.trackNumber != this.aggregatedTrack?.trackNumber || key !== editor.editorPopup.output.id)) {
								if (__DEBUG__)
									console.debug(`applyEditingOutputValueToAllTracks true`, { key, params });
								this.$set(aggTrack.condition.params, key, _.cloneDeep(params));
								this.$set(aggTrack.condition.paramsCaptions, key, _.cloneDeep(paramsCaptions));
							}
						});
					}
				});
			},
			show(aggTrack) {
				this.aggregatedTrack = aggTrack;
				this.$refs.commonEditor.show(aggTrack.condition);
			},
			save(value) {
				if (__DEBUG__)
					console.debug('Save', { value });
				
				if (this.aggregatedTrack) {
					this.$set(this.aggregatedTrack, 'condition', value);
				}
			}
		}
	};
</script>
<style lang='scss'>
	.creative--aggregated-track-criteria-editor {
	}
</style>
